export const maintenanceConstants = {

    /* ===========================================
       GLOBAL
    =========================================== */
    SET_LOADING: "MAINTENANCE_SET_LOADING",
  
  
    /* ===========================================
       ROOM TYPES
    =========================================== */
    GET_ROOM_TYPES_REQUEST: "GET_ROOM_TYPES_REQUEST",
    GET_ROOM_TYPES_SUCCESS: "GET_ROOM_TYPES_SUCCESS",
    GET_ROOM_TYPES_FAILURE: "GET_ROOM_TYPES_FAILURE",
  
  
    /* ===========================================
       CATEGORY TYPES
    =========================================== */
    GET_CATEGORY_TYPES_REQUEST: "GET_CATEGORY_TYPES_REQUEST",
    GET_CATEGORY_TYPES_SUCCESS: "GET_CATEGORY_TYPES_SUCCESS",
    GET_CATEGORY_TYPES_FAILURE: "GET_CATEGORY_TYPES_FAILURE",
  
  
    /* ===========================================
       FLOWS
    =========================================== */
    GET_FLOWS_REQUEST: "GET_FLOWS_REQUEST",
    GET_FLOWS_SUCCESS: "GET_FLOWS_SUCCESS",
    GET_FLOWS_FAILURE: "GET_FLOWS_FAILURE",
  
    GET_FLOW_ISSUES_REQUEST: "GET_FLOW_ISSUES_REQUEST",
    GET_FLOW_ISSUES_SUCCESS: "GET_FLOW_ISSUES_SUCCESS",
    GET_FLOW_ISSUES_FAILURE: "GET_FLOW_ISSUES_FAILURE",
  
  
    /* ===========================================
       ISSUES
    =========================================== */
    GET_ISSUES_REQUEST: "GET_ISSUES_REQUEST",
    GET_ISSUES_SUCCESS: "GET_ISSUES_SUCCESS",
    GET_ISSUES_FAILURE: "GET_ISSUES_FAILURE",
  
    ADD_ISSUE_REQUEST: "ADD_ISSUE_REQUEST",
    ADD_ISSUE_SUCCESS: "ADD_ISSUE_SUCCESS",
    ADD_ISSUE_FAILURE: "ADD_ISSUE_FAILURE",
  
    UPDATE_ISSUE_REQUEST: "UPDATE_ISSUE_REQUEST",
    UPDATE_ISSUE_SUCCESS: "UPDATE_ISSUE_SUCCESS",
    UPDATE_ISSUE_FAILURE: "UPDATE_ISSUE_FAILURE",
  
    SUMMARIZE_ISSUE_REQUEST: "SUMMARIZE_ISSUE_REQUEST",
    SUMMARIZE_ISSUE_SUCCESS: "SUMMARIZE_ISSUE_SUCCESS",
    SUMMARIZE_ISSUE_FAILURE: "SUMMARIZE_ISSUE_FAILURE",
  
    UPDATE_ISSUE_STATUS_REQUEST: "UPDATE_ISSUE_STATUS_REQUEST",
    UPDATE_ISSUE_STATUS_SUCCESS: "UPDATE_ISSUE_STATUS_SUCCESS",
    UPDATE_ISSUE_STATUS_FAILURE: "UPDATE_ISSUE_STATUS_FAILURE",
  
  
    /* ===========================================
       PROJECTS
    =========================================== */
    GET_PROJECTS_REQUEST: "GET_PROJECTS_REQUEST",
    GET_PROJECTS_SUCCESS: "GET_PROJECTS_SUCCESS",
    GET_PROJECTS_FAILURE: "GET_PROJECTS_FAILURE",
    
    GET_PROJECTS_I_REQUEST: "GET_PROJECTS_I_REQUEST",
    GET_PROJECTS_I_SUCCESS: "GET_PROJECTS_I_SUCCESS",
    GET_PROJECTS_I_FAILURE: "GET_PROJECTS_I_FAILURE",
  
    GET_COMPLETED_PROJECTS_REQUEST: "GET_COMPLETED_PROJECTS_REQUEST",
    GET_COMPLETED_PROJECTS_SUCCESS: "GET_COMPLETED_PROJECTS_SUCCESS",
    GET_COMPLETED_PROJECTS_FAILURE: "GET_COMPLETED_PROJECTS_FAILURE",
  
    GET_ARCHIVED_PROJECTS_REQUEST: "GET_ARCHIVED_PROJECTS_REQUEST",
    GET_ARCHIVED_PROJECTS_SUCCESS: "GET_ARCHIVED_PROJECTS_SUCCESS",
    GET_ARCHIVED_PROJECTS_FAILURE: "GET_ARCHIVED_PROJECTS_FAILURE",
  
    CREATE_PROJECT_REQUEST: "CREATE_PROJECT_REQUEST",
    CREATE_PROJECT_SUCCESS: "CREATE_PROJECT_SUCCESS",
    CREATE_PROJECT_FAILURE: "CREATE_PROJECT_FAILURE",
  
    UPDATE_PROJECT_REQUEST: "UPDATE_PROJECT_REQUEST",
    UPDATE_PROJECT_SUCCESS: "UPDATE_PROJECT_SUCCESS",
    UPDATE_PROJECT_FAILURE: "UPDATE_PROJECT_FAILURE",
  
    ARCHIVE_PROJECT_REQUEST: "ARCHIVE_PROJECT_REQUEST",
    ARCHIVE_PROJECT_SUCCESS: "ARCHIVE_PROJECT_SUCCESS",
    ARCHIVE_PROJECT_FAILURE: "ARCHIVE_PROJECT_FAILURE",
  
    UNARCHIVE_PROJECT_REQUEST: "UNARCHIVE_PROJECT_REQUEST",
    UNARCHIVE_PROJECT_SUCCESS: "UNARCHIVE_PROJECT_SUCCESS",
    UNARCHIVE_PROJECT_FAILURE: "UNARCHIVE_PROJECT_FAILURE",
  
  
    /* ===========================================
       PROJECT ISSUES
    =========================================== */
    GET_ISSUE_PROJECT_REQUEST: "GET_ISSUE_PROJECT_REQUEST",
    GET_ISSUE_PROJECT_SUCCESS: "GET_ISSUE_PROJECT_SUCCESS",
    GET_ISSUE_PROJECT_FAILURE: "GET_ISSUE_PROJECT_FAILURE",
  
  
    /* ===========================================
       COMMENTS
    =========================================== */
    ADD_COMMENT_REQUEST: "ADD_COMMENT_REQUEST",
    ADD_COMMENT_SUCCESS: "ADD_COMMENT_SUCCESS",
    ADD_COMMENT_FAILURE: "ADD_COMMENT_FAILURE",
  
    EDIT_COMMENT_REQUEST: "EDIT_COMMENT_REQUEST",
    EDIT_COMMENT_SUCCESS: "EDIT_COMMENT_SUCCESS",
    EDIT_COMMENT_FAILURE: "EDIT_COMMENT_FAILURE",
  
    DELETE_COMMENT_REQUEST: "DELETE_COMMENT_REQUEST",
    DELETE_COMMENT_SUCCESS: "DELETE_COMMENT_SUCCESS",
    DELETE_COMMENT_FAILURE: "DELETE_COMMENT_FAILURE",
    GET_PROJECTS_COMPLETED_REQUEST:"GET_PROJECTS_COMPLETED_REQUEST",
    GET_PROJECTS_COMPLETED_SUCCESS:"GET_PROJECTS_COMPLETED_SUCCESS",
    GET_PROJECTS_COMPLETED_FAILURE:"GET_PROJECTS_COMPLETED_FAILURE"
  }
  